/* Alexa's Gifts cart extras: reservation timer, ShineOn package protection, terms tick + timestamp.
   Works in the cart drawer (snippets/cart-drawer.liquid) and on /cart (main-cart-footer). */
(function () {
  if (window.__agCart) return;
  window.__agCart = true;
  // Load the companion file (preview lightbox, drawer thumbnails) from the same assets folder.
  (function () {
    var me = document.currentScript && document.currentScript.src;
    if (!me || window.__agCartExtra) return;
    var s = document.createElement('script');
    s.src = me.replace('/ag-cart.js', '/ag-cart-extra.js');
    s.defer = true;
    document.head.appendChild(s);
  })();

  var PP_HANDLE = 'package-protection';
  // ShineOn "Package Protection" variants by cart subtotal (cents): <$100, $100+, $200+ ...
  var PP_TIERS = [
    [0, 41242278396098],
    [10000, 41242278428866],
    [20000, 41242278461634],
    [30000, 41242278494402],
    [40000, 41242278527170],
    [50000, 41242278559938]
  ];
  var PP_IDS = PP_TIERS.map(function (t) { return t[1]; });
  var TERMS_KEY = 'Agreed to the Terms and Conditions on';
  var TIMER_KEY = 'ag_cart_timer_end';
  var termsOk = true;
  var busy = false;
  var queued = false;
  var onCartPage = /^\/cart\/?$/.test(location.pathname);

  function post(url, data) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function isPP(item) { return PP_IDS.indexOf(item.variant_id) > -1 || item.handle === PP_HANDLE; }

  function wantedVariant(cart) {
    var goods = cart.items.filter(function (i) { return !isPP(i); });
    if (!goods.length) return null;
    if (cart.attributes && cart.attributes._pp_optout === '1') return null;
    var sub = goods.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var id = PP_TIERS[0][1];
    PP_TIERS.forEach(function (t) { if (sub >= t[0]) id = t[1]; });
    return id;
  }

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function refreshUI() {
    if (onCartPage) { location.reload(); return Promise.resolve(); }
    var drawer = document.querySelector('cart-drawer');
    return fetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (drawer && s['cart-drawer']) {
          var src = parse(s['cart-drawer']).querySelector('#CartDrawer');
          var dst = document.getElementById('CartDrawer');
          if (src && dst) {
            dst.innerHTML = src.innerHTML;
            var ov = dst.querySelector('#CartDrawer-Overlay');
            if (ov) ov.addEventListener('click', function () { drawer.close(); });
            var empty = !dst.querySelector('.ag-cd__line');
            drawer.classList.toggle('is-empty', empty);
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var b = parse(s['cart-icon-bubble']).querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
        applyState();
      })
      .catch(function () {});
  }

  function syncProtection() {
    if (busy) { queued = true; return Promise.resolve(); }
    busy = true;
    return getCart()
      .then(function (cart) {
        var want = wantedVariant(cart);
        var updates = {};
        var change = false;
        var hasPP = false;
        cart.items.forEach(function (i) {
          if (!isPP(i)) return;
          hasPP = true;
          if (i.variant_id !== want) { updates[i.variant_id] = 0; change = true; }
          else if (i.quantity !== 1) { updates[i.variant_id] = 1; change = true; }
        });
        if (want && !cart.items.some(function (i) { return i.variant_id === want; })) { updates[want] = 1; change = true; }
        if (change) return post('/cart/update.js', { updates: updates }).then(refreshUI);
        if (hasPP && !onCartPage && !window.__agBubbleFixed) { window.__agBubbleFixed = true; return refreshUI(); }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (queued) { queued = false; return syncProtection(); }
      });
  }

  function setOptOut(optOut) {
    return post('/cart/update.js', { attributes: { _pp_optout: optOut ? '1' : '0' } }).then(syncProtection);
  }

  function stampTerms() {
    var attrs = {};
    attrs[TERMS_KEY] = new Date().toString();
    return post('/cart/update.js', { attributes: attrs }).catch(function () {});
  }

  /* ---------- terms tick ---------- */
  function applyState() {
    document.querySelectorAll('[data-ag-terms]').forEach(function (cb) {
      cb.checked = termsOk;
      var wrap = cb.closest('[data-ag-terms-wrap]');
      if (wrap) wrap.classList.toggle('is-unticked', !termsOk);
      if (termsOk && wrap) { var e = wrap.querySelector('[data-ag-terms-error]'); if (e) e.hidden = true; }
    });
    document.querySelectorAll('#CartDrawer-Checkout, #checkout').forEach(function (btn) {
      btn.classList.toggle('ag-blocked', !termsOk);
      btn.setAttribute('aria-disabled', termsOk ? 'false' : 'true');
    });
    linkifyProps();
    tick();
  }

  // Cart page: show uploaded/preview URLs in line-item properties as a short link.
  function linkifyProps() {
    document.querySelectorAll('.ag-cd__opt').forEach(function (p) {
      if (p.querySelector('a')) return;
      var m = (p.textContent || '').trim().match(/^([^:]+):\s*(https?:\/\/\S+)$/);
      if (!m) return;
      p.textContent = m[1] + ': ';
      var a = document.createElement('a');
      a.href = m[2]; a.target = '_blank'; a.rel = 'noopener'; a.textContent = 'View image';
      a.style.color = 'inherit'; a.style.textDecoration = 'underline';
      p.appendChild(a);
    });
    document.querySelectorAll('.cart-item .product-option dd').forEach(function (dd) {
      if (dd.querySelector('a')) return;
      var t = (dd.textContent || '').trim();
      if (!/^https?:\/\/\S+$/.test(t)) return;
      dd.textContent = '';
      var a = document.createElement('a');
      a.href = t; a.target = '_blank'; a.rel = 'noopener'; a.className = 'link'; a.textContent = 'View image';
      dd.appendChild(a);
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-ag-terms]')) {
      termsOk = t.checked;
      applyState();
      if (termsOk) stampTerms();
    }
    if (t.matches && t.matches('[data-ag-pp-toggle]')) {
      var row = t.closest('[data-ag-pp]');
      if (row) row.classList.toggle('is-on', t.checked);
      setOptOut(!t.checked);
    }
  });

  document.addEventListener('click', function (e) {
    var more = e.target.closest && e.target.closest('[data-ag-pp-more]');
    if (more) {
      var d = more.closest('[data-ag-pp]').querySelector('.ag-pp__details');
      if (d) { d.hidden = !d.hidden; more.setAttribute('aria-expanded', String(!d.hidden)); more.textContent = d.hidden ? 'Learn more' : 'Show less'; }
      return;
    }
    var btn = e.target.closest && e.target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"]');
    if (!btn) return;
    var scope = btn.closest('cart-drawer, form, .cart__footer, main') || document;
    var hasBox = scope.querySelector('[data-ag-terms]') || document.querySelector('[data-ag-terms]');
    if (!hasBox) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!termsOk) {
      document.querySelectorAll('[data-ag-terms-error]').forEach(function (el) { el.hidden = false; });
      document.querySelectorAll('[data-ag-terms-wrap]').forEach(function (w) { w.classList.add('is-unticked'); });
      var vis = document.querySelector('cart-drawer.active [data-ag-terms-wrap]') || document.querySelector('[data-ag-terms-wrap]');
      if (vis && vis.scrollIntoView) vis.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }
    btn.disabled = true;
    stampTerms().then(function () { window.location.href = '/checkout'; });
  }, true);

  // Express buttons on the cart page (Shop Pay / PayPal / Google Pay) skip our button: stamp first.
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('.additional-checkout-buttons, .cart__dynamic-checkout-buttons, shopify-accelerated-checkout-cart')) {
      if (termsOk) stampTerms();
    }
  }, true);

  /* ---------- keep add-to-cart in the drawer ----------
     Some apps (e.g. personalisation) submit the product form natively, which lands on /cart.
     When a cart drawer exists, do the add over AJAX and open the drawer instead. */
  function isAddForm(f) { return f && f.tagName === 'FORM' && /\/cart\/add/.test(f.getAttribute('action') || ''); }
  function openDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    if (typeof d.open === 'function') d.open(); else d.classList.add('animate', 'active');
  }
  function ajaxAdd(form) {
    var fd = new FormData(form);
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return syncProtection(); })
      .then(function () { return refreshUI(); })
      .then(openDrawer);
  }
  var nativeSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    var f = this;
    if (!onCartPage && isAddForm(f) && document.querySelector('cart-drawer')) {
      ajaxAdd(f).catch(function () { nativeSubmit.call(f); });
      return;
    }
    return nativeSubmit.call(f);
  };
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || onCartPage || !isAddForm(f) || !document.querySelector('cart-drawer')) return;
    e.preventDefault();
    ajaxAdd(f).catch(function () { nativeSubmit.call(f); });
  });

  /* ---------- reservation timer ---------- */
  function timerEnd(minutes) {
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(TIMER_KEY) || '0', 10); } catch (e) {}
    var now = Date.now();
    if (!end || end <= now) {
      end = now + minutes * 60000;
      try { sessionStorage.setItem(TIMER_KEY, String(end)); } catch (e) {}
    }
    return end;
  }
  function tick() {
    var els = document.querySelectorAll('[data-ag-timer]');
    if (!els.length) return;
    var mins = parseInt(els[0].getAttribute('data-minutes') || '10', 10);
    var left = Math.max(0, timerEnd(mins) - Date.now());
    var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
    var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    els.forEach(function (el) { var c = el.querySelector('[data-ag-timer-clock]'); if (c && c.textContent !== txt) c.textContent = txt; });
  }
  setInterval(tick, 1000);

  /* ---------- keep state after Dawn re-renders the drawer ---------- */
  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () { applyState(); }).observe(drawer, { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(syncProtection, 250); });
    }
    // Anything else that adds to cart (apps, upsells) without pub/sub
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change)(\.js)?/.test(url) && !(init && init.__ag)) {
        p.then(function () { setTimeout(syncProtection, 600); }).catch(function () {});
      }
      return p;
    };
    applyState();
    syncProtection();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
